export var getUnreadMessageCount = function (state) {
    return state.conversations.reduce(function (acc, c) { return acc + c.unread.length; }, 0);
};
